import { ParallaxMover } from "./ParallaxMover";
export async function loadParallaxMover(engine, refresh = true) {
    await engine.addMover("parallax", () => new ParallaxMover(), refresh);
}
